import ErrorBoundary from './error-boundary'
import GenericError from './generic-error'

export { ErrorBoundary, GenericError }
